import {Card, CardContent, CardHeader, CardTitle} from '@/components/ui/card'
import {Users2Icon} from 'lucide-react'
import {useCalculator} from '@/contexts/CalculatorContext'

export function NastupyTable() {
    const { 
        nastupy,
        getNastupyPercentage,
    } = useCalculator()
    
    const currentBonus = getNastupyPercentage(nastupy)
    const currentBonusFormatted = currentBonus.toFixed(2).replace('.', ',') + '%'
    
    return (
        <Card className="w-full">
            <CardHeader>
                <div className="flex items-center gap-2">
                    <Users2Icon className="w-5 h-5 text-primary"/>
                    <div>
                        <CardTitle>2. složka</CardTitle>
                        <p className="text-sm text-muted-foreground mt-1">
                            Absolutní počet nástupů za půlrok<br/>
                            Extra bonus pro příští období 6 mesíců
                        </p>
                    </div>
                </div>
            </CardHeader>
            <CardContent className="space-y-4">
                <div className="space-y-2">
                    {[
                        {range: '8 nástupů', percentage: '3,00%'},
                        {range: '9 nástupů', percentage: '3,25%'},
                        {range: '10 nástupů', percentage: '3,50%'},
                        {range: '11 nástupů', percentage: '3,75%'},
                        {range: '≥ 12 nástupů', percentage: '4,00%'},
                    ].map((item, index) => (
                        <div
                            key={index}
                            className={`flex justify-between py-2 border-b last:border-0 ${
                                item.percentage === currentBonusFormatted 
                                    ? 'bg-green-50 px-2 rounded-md font-medium' 
                                    : ''
                            }`}
                        >
                            <span className={`${
                                item.percentage === currentBonusFormatted 
                                    ? 'text-green-700' 
                                    : 'text-muted-foreground'
                            }`}>
                                {item.range}
                            </span>
                            <span className={`${
                                item.percentage === currentBonusFormatted 
                                    ? 'text-green-700' 
                                    : 'font-medium'
                            }`}>
                                {item.percentage}
                            </span>
                        </div>
                    ))}
                </div>
            </CardContent>
        </Card>
    )
} 